import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
	{
		path: '/login',
		name: '登录',
		meta: {
			title: '登录',
			isLogin: false,
		},
		component: resolve => require(['@/views/login/login.vue'], resolve),
	},
	{
		path: '/',
		name: '欢迎',
		meta: {
			title: '欢迎',
			isLogin: true,
		},
		component: resolve => require(['@/views/Home.vue'], resolve),
		redirect: '/welcome',
		children: [
			{
				path: '/welcome',
				name: '欢迎',
				meta: {
					title: '欢迎',
					isLogin: true,
				},
				component: resolve => require(['@/views/welcome/welcome'], resolve),
			},
		],
	},
	{
		path: '/',
		name: 'Pipeline服务',
		meta: {
			title: 'Pipeline服务',
			isLogin: true,
		},
		component: resolve => require(['@/views/Home.vue'], resolve),
		children: [
			{
				path: '/pipelineConfig',
				name: 'Pipeline配置',
				meta: {
					title: 'Pipeline配置',
					isLogin: true,
				},
				component: resolve => require(['@/views/pipelineService/pipelineConfig'], resolve),
			},
			{
				path: '/pipelineConfigForm',
				name: 'Pipeline配置表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/pipelineService/pipelineConfig/form.vue'], resolve),
			},
			{
				path: '/pipelineControl',
				name: 'Pipeline控制',
				meta: {
					title: 'Pipeline控制',
					isLogin: true,
				},
				component: resolve => require(['@/views/pipelineService/pipelineControl'], resolve),
			},
			{
				path: '/serviceConfig',
				name: '提交服务配置',
				meta: {
					title: '提交服务配置',
					isLogin: true,
				},
				component: resolve => require(['@/views/pipelineService/serviceConfig'], resolve),
			},
			{
				path: '/serviceConfigForm',
				name: '提交服务配置表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/pipelineService/serviceConfig/form.vue'], resolve),
			},
		],
	},
	{
		path: '/',
		name: '数据源服务',
		meta: {
			title: '数据源服务',
			isLogin: true,
		},
		component: resolve => require(['@/views/Home.vue'], resolve),
		children: [
			{
				path: '/sinkConfig',
				name: 'Sink配置',
				meta: {
					title: 'Sink配置',
					isLogin: true,
				},
				component: resolve => require(['@/views/dataSourceService/sinkConfig'], resolve),
			},
			{
				path: '/sinkConfigForm',
				name: 'Sink配置表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/dataSourceService/sinkConfig/form.vue'], resolve),
			},
			{
				path: '/sourceConfig',
				name: 'Source配置',
				meta: {
					title: 'Source配置',
					isLogin: true,
				},
				component: resolve => require(['@/views/dataSourceService/sourceConfig'], resolve),
			},
			{
				path: '/sourceConfigForm',
				name: 'Source配置表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/dataSourceService/sourceConfig/form.vue'], resolve),
			},
			{
				path: '/databaseManagement',
				name: '物理数据库管理',
				meta: {
					title: '物理数据库管理',
					isLogin: true,
				},
				component: resolve => require(['@/views/dataSourceService/databaseManagement'], resolve),
			},
			{
				path: '/databaseManagementForm',
				name: '物理数据库管理表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/dataSourceService/databaseManagementForm'], resolve),
			},
			{
				path: '/logicManagement',
				name: '逻辑库管理',
				meta: {
					title: '逻辑库管理',
					isLogin: true,
				},
				component: resolve => require(['@/views/dataSourceService/logicManagement'], resolve),
			},
			{
				path: '/logicManagementForm',
				name: '逻辑库管理表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/dataSourceService/logicManagementForm'], resolve),
			},
		],
	},
	{
		path: '/',
		name: 'kafka集群服务',
		meta: {
			title: 'kafka集群服务',
			isLogin: true,
		},
		component: resolve => require(['@/views/Home.vue'], resolve),
		children: [
			{
				path: '/kafkaConfig',
				name: 'kafka集群配置',
				meta: {
					title: 'kafka集群配置',
					isLogin: true,
				},
				component: resolve => require(['@/views/kafkaService/kafkaConfig'], resolve),
			},
			{
				path: '/kafkaConfigForm',
				name: 'kafka集群配置表单',
				meta: {
					title: '表单',
					isLogin: true,
				},
				hidden: true,
				component: resolve => require(['@/views/kafkaService/kafkaConfigForm'], resolve),
			},
		],
	},
];

const router = new VueRouter({
	mode: 'history', // 有这句的删掉，没有就不用管
	base: process.env.BASE_URL,
	routes,
});

export default router;
